import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import FileUpload from "components/UploadArquivos";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toastErro } from "components/Toast";
import { CaixaCampos, Descricao, FooterBotoes } from "./style";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: (arquivo: File) => void;
}

export function ModalAnexarRecibo({ show, handleClose, onConfirm }: IProps) {
  const [arquivo, setArquivo] = useState<File | null>(null);

  useEffect(() => {
    if (!show) setArquivo(null);
  }, [show]);

  const handleConfirm = () => {
    if (!arquivo) {
      toastErro("Selecione um arquivo para anexar");
      return;
    }
    onConfirm(arquivo);
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Upload Recibo / NF"
      centered
      footer
      footerTools={
        <FooterBotoes>
          <PrimaryButton outline variante="primary" onClick={handleClose}>
            Cancelar
          </PrimaryButton>
          <PrimaryButton onClick={handleConfirm}>Salvar</PrimaryButton>
        </FooterBotoes>
      }
    >
      <Descricao>Realize o upload do Recibo / NF do lote.</Descricao>
      <CaixaCampos>
        <Form.Group>
          <Form.Label>Upload do arquivo</Form.Label>
          <FileUpload
            id="uploadReciboAprovado"
            onFileUpload={(file) => setArquivo(file)}
            inputAccept=""
            fileInicial={arquivo}
          />
        </Form.Group>
      </CaixaCampos>
    </ModalCustom>
  );
}
